import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import "../../assets/css/icon.css";

const ModalConfermaAml = ({
  onClose,
  confirm,
  title,
  descriptionOne,
  descriptionTwo,
  copyButtonConfirm,
  copyButtonClose,
}) => {
  return (
    <Grid
      container
      item
      xs={11}
      md={5}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "100%",
        width: { xs: "90%", sm: "80%" },
        borderRadius: "16px",
        outline: "none",
      }}
    >
      {/* ── Header ── */}
      <Grid
        item
        xs={12}
        style={{
          height: "60px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
        }}
      >
        <Grid item xs={1} style={{ marginLeft: "15px" }}>
          <div className="icon-modal-info" />
        </Grid>
        <Grid item xs={10} sx={{ ml: { xs: 3, sm: 1 } }}>
          <Typography
            className="color-blue-dark"
            style={{ fontSize: "18px", fontWeight: 600 }}
          >
            {title}
          </Typography>
        </Grid>
        <Grid
          item
          xs={1}
          style={{
            marginRight: "15px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div onClick={onClose} className="icon-modal-close" />
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          className="color-blue-dark"
          style={{ padding: "10px 15px 0px 15px", marginTop: "20px" }}
        >
          {descriptionOne}
        </Typography>
        <Typography className="color-blue-dark" style={{ padding: "0px 15px" }}>
          {descriptionTwo}
        </Typography>
      </Grid>

      {/*  Footer  */}
      <Grid container item xs={12} style={{ marginTop: "20px" }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "20px",
          }}
        >
          {/* <Button
            variant="outlined"
            className="button-bg-empty-small"
            onClick={onClose}
            sx={{ height: "40px", width: { xs: "120px", md: "140px" } }}
          >
            <Typography
              className="color-blue-dark"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {copyButtonClose}
            </Typography>
          </Button> */}

          <Button
            className="button-bg-purple"
            onClick={confirm}
            sx={{ height: "40px", width: { xs: "120px", md: "140px" } }}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {copyButtonConfirm}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalConfermaAml;
